/*global Calendly */
import ThankYou from "../../components/form/thank-you";

import {
  calendly_view,
  calendly_meeting_scheduled,
  calendly_select_date_and_time,
  createLinkEl,
} from "./util";
import { TESTING_CALENDLY } from "./constants";
import { app, DEVELOPMENT } from "../../../../config/env";

const isCalendlyEvent = (e) =>
  e.data.event && e.data.event.indexOf("calendly") === 0;

const calendlyListener = ({
  viewedCallback,
  selectedTimeCallback,
  scheduledCallback,
}) => {
  window.addEventListener("message", (e) => {
    if (isCalendlyEvent(e)) {
      const event = e.data.event;
      if (event === "calendly.event_type_viewed") {
        calendly_view();
        viewedCallback && viewedCallback();
      }

      if (event === "calendly.date_and_time_selected") {
        calendly_select_date_and_time();
        selectedTimeCallback && selectedTimeCallback();
      }

      if (event === "calendly.event_scheduled") {
        calendly_meeting_scheduled();
        scheduledCallback && scheduledCallback();

        let form = document.querySelector(".js-calendly")
          ? document
              .querySelector(".js-calendly")
              .parentElement.querySelector("form")
          : false;

        if (form) {
          ThankYou.init();
        } else {
          ThankYou.init();
        }
      }
    }
  });
};

export const setupCalendly = () => {
  //  load Calendly CSS
  createLinkEl($("head"));

  //  load Calendly JS
  const CalendlyJs = "https://assets.calendly.com/assets/external/widget.js";

  return $.getScript(CalendlyJs);
};

const initCalendly = (calendlyLink, prefill) => {
  prefill;
  const calendlyWrapper = document.querySelectorAll(".js-calendly");

  if (calendlyWrapper.length) {
    calendlyWrapper.forEach((elem) => {
      Calendly.initInlineWidget({
        url: calendlyLink,
        parentElement: elem,
      });
    });
  } else {
    Calendly.initPopupWidget({ url: calendlyLink });
  }
};

export const calendly = (link, prefill, listenerCallback) => {
  //  listen to Calendly events
  calendlyListener(listenerCallback);

  const calendlyLink = app.appEnv === DEVELOPMENT ? TESTING_CALENDLY : link;

  //  if Calendly is already loaded

  if (window.Calendly) {
    initCalendly(calendlyLink, prefill);
    return;
  }

  setupCalendly().then(() => {
    initCalendly(calendlyLink, prefill);
  });
};
